var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('circle',{attrs:{"cx":"12.0002","cy":"12","r":"6.85714"}})])}
var staticRenderFns = []

export { render, staticRenderFns }